import { render, staticRenderFns } from "./AdminNovelties.vue?vue&type=template&id=301167f3"
import script from "./AdminNovelties.vue?vue&type=script&lang=js"
export * from "./AdminNovelties.vue?vue&type=script&lang=js"
import style0 from "./AdminNovelties.vue?vue&type=style&index=0&id=301167f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports